import { createApp } from 'vue';
import Woff2ToWoffConverter from '@/Components/Woff2ToWoffConverter.vue';
import '@styles/app.css';

createApp(Woff2ToWoffConverter).mount('#woff2-to-woff-converter');
